export default __webpack_public_path__ + "static/media/AI.5420756b.jpeg";